// @flow
import React from 'react';
import ProfileEmptyState from 'app/common/react/components/profile/ProfileEmptyState/ProfileEmptyState';
import ProfileEmptyStateText from 'app/common/react/components/profile/ProfileEmptyState/ProfileEmptyStateText';
import TimeSpent from 'app/common/lib/react/TimeSpent';
import withResource from 'app/common/lib/react/withResource';
import { Box } from 'gestalt';
import { compose } from 'redux';
import { UserProfilePinGrid } from 'app/common/react/components/profile/UserProfilePinGrid/UserProfilePinGrid';
import type { PinFeedFilterOptionsType, ProfileUser } from 'app/packages/pinterest-flow-types/user';
import withViewer, { type Viewer } from 'app/common/lib/react/withViewer';

type Props = {|
  isOwnProfile: boolean,
  pinFeedFilter?: PinFeedFilterOptionsType,
  pins: {
    data: Array<Object>,
    fetchMore: () => void,
    isFetching: boolean,
    isLoaded: boolean,
    refreshData: () => void,
  },
  user: ProfileUser,
  username: string,
  viewer: Viewer,
|};

function BusinessProfileUserPinsGrid({ isOwnProfile, user, pins, pinFeedFilter, viewer }: Props) {
  const timeSpentViewParam = isOwnProfile
    ? PCONST.thrift.ViewParameterType.USER_SELF
    : PCONST.thrift.ViewParameterType.USER_OTHERS;

  if (!user || !pins || !pins.data || pins.data.length === 0) {
    return (
      <ProfileEmptyState>
        <ProfileEmptyStateText subject="pins" surface="profile" user={user} />
      </ProfileEmptyState>
    );
  }

  return (
    <Box>
      <TimeSpent
        view={PCONST.thrift.ViewType.USER}
        viewParameter={timeSpentViewParam}
        component={PCONST.thrift.ComponentType.USER_PINS}
      >
        <UserProfilePinGrid
          isOverview={false}
          isOwnProfile={isOwnProfile}
          user={user}
          username={user.username}
          pins={pins}
          viewer={viewer}
          showNativePins
        />
      </TimeSpent>
    </Box>
  );
}

export default compose(
  withViewer,
  withResource({
    name: 'BusinessProfileUserPinsResource',
    key: 'pins',
    options: (props) => ({
      exclude_add_pin_rep: true,
      username: props.username,
      is_own_profile_pins: props.isOwnProfile,
      pinFeedFilter: props.isOwnProfile ? props.pinFeedFilter : undefined,
      user_id: props.user.id,
      field_set_key:
        props.viewer.isPartner && props.isOwnProfile ? 'partner_grid_item' : 'grid_item',
    }),
  }),
)(BusinessProfileUserPinsGrid);
